import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './EmailConfirmed.css';

const EmailConfirmed: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.log('🔄 EmailConfirmed - Redirecting to login page with URL parameters...');
    console.log('🔍 Current URL:', window.location.href);
    
    // Redirect to login page with all the same URL parameters
    // This ensures the LoginPage can handle the email confirmation
    const searchParams = location.search;
    const loginUrl = `/login${searchParams}`;
    
    console.log('🔄 Redirecting to:', loginUrl);
    navigate(loginUrl, { replace: true });
  }, [navigate, location]);

  // Show a brief loading state while redirecting
  return (
    <div className="email-confirmed-container">
      <div className="email-confirmed-card">
        <div className="spinner"></div>
        <h2>Processing email confirmation...</h2>
        <p>Redirecting you to complete the verification process.</p>
      </div>
    </div>
  );
};

export default EmailConfirmed; 